'use strict';

var React = require('react'),
    FormInput = require('../atoms/FormInput'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    FormLink = require('../utils/FormLink'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

require('./FormInputRow.less');

var FormInputRow = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    component: React.PropTypes.func,
    formLink: React.PropTypes.instanceOf(FormLink).isRequired,
    valueLink: function (props, propName) {
      if (props[propName]) {
        console.warn('Cannot use valueLink with FormInputRow. Use formLink instead.');
      }
    },
    placeholder: React.PropTypes.string,
    label: React.PropTypes.string,
    color: React.PropTypes.oneOf(['light', 'dark']).isRequired,
    size: React.PropTypes.oneOf(['big', 'medium']).isRequired,
    blended: React.PropTypes.bool,
    borderless: React.PropTypes.bool,
    type: React.PropTypes.string,
    name: React.PropTypes.string,
    readOnly: React.PropTypes.bool,
    bold: React.PropTypes.bool,
    autofill: React.PropTypes.bool
  },

  className: 'FormInputRow',

  getDefaultProps: function () {
    return {
      color: 'dark',
      size: 'medium'
    };
  },

  getCSSModifiers: function () {
    var fieldMessage = this.props.formLink.fieldMessage,
        isError = fieldMessage && fieldMessage.isError;

    return [
      this.props.color,
      this.props.size,
      isError && 'error',
      this.props.blended && 'blended',
      this.props.borderless && 'borderless'
    ];
  },

  getInitialState: function () {
    return {
      focus: false
    };
  },

  handleBlur: function (e) {
    this.setState({
      focus: false
    });

    if (this.props.onBlur) {
      this.props.onBlur(e);
    }
  },

  handleFocus: function (e) {
    this.setState({
      focus: true
    });

    if (this.props.onFocus) {
      this.props.onFocus(e);
    }
  },

  handleKeyUp: function (e) {
    if (this.props.onKeyUp) {
      this.props.onKeyUp(e);
    }
  },

  isEmpty: function () {
    var value = this.props.formLink.value;
    if (!value) {
      return true;
    }

    if (typeof value.isEmpty === 'function') {
      return value.isEmpty();
    }

    return false;
  },

  render: function () {
    var formLink = this.props.formLink;

    return (
      <div className={this.getClassName()}
           data-empty={this.isEmpty()}
           data-focus={this.state.focus}
           onMouseDown={this.handleInputBoxClick}>

        {this.props.label &&
          <label className='FormInputRow-label'>
            {this.props.label}
          </label>
        }

        <div className='FormInputRow-inputBox'>
          <FormInput ref='input'
                     component={this.props.component}
                     formLink={formLink}
                     color={this.props.color}
                     type={this.props.type}
                     name={this.props.name}
                     readOnly={this.props.readOnly}
                     placeholder={this.props.placeholder || this.props.label}
                     onFocus={this.handleFocus}
                     onBlur={this.handleBlur}
                     onKeyUp={this.handleKeyUp}
                     autofill={this.props.autofill} />
        </div>
        {this.renderMessage()}
      </div>
    );
  },

  handleInputBoxClick: function (e) {
    var inputEl = this.refs.input.getDOMNode();

    if (inputEl !== e.target && !inputEl.contains(e.target)) {
      e.preventDefault();
      this.refs.input.focus();
    }
  },

  renderMessage: function () {
    var formLink = this.props.formLink,
        fieldMessage = formLink.fieldMessage;

    if (!fieldMessage) {
      return;
    }

    if (!fieldMessage.isError) {
      return (
        <div className='FormInputRow-help'>
          {fieldMessage.message}
        </div>
      );
    }

    // hasFormError will get reset on next tick,
    // so we use it to trigger the animation

    var animateShake = !formLink.hasFormError;
    return (
      <div className='FormInputRow-error'
           data-animate={animateShake}>
        {fieldMessage.message}
      </div>
    );
  },

  focus: function () {
    this.refs.input.focus();
  }
});

module.exports = FormInputRow;



/** WEBPACK FOOTER **
 ** ./molecules/FormInputRow.jsx
 **/